import React, { useState } from "react";
import terapias_osteopatia from "../assets/Terapias/terapias_osteopatia.png";
import terapias_nutricao from "../assets/Terapias/terapias_nutricao.png";
import terapias_fisio from "../assets/Terapias/terapias_fisio.png";
import terapias_massagem from "../assets/Terapias/terapias_massagem.png";
import terapias_estetica from "../assets/Terapias/terapias_estetica.png";
import terapias_presso from "../assets/Terapias/terapias_presso.png";
import terapias_drenagem from "../assets/Terapias/terapias_drenagem.png";
import terapias_relax from "../assets/Terapias/terapias_relax.png";

import "../css/Terapias.css";

const TerapiasComponent = () => {
  const terapiasData = [
    {
      id: 1,
      image: terapias_fisio,
      title: "Fisioterapia",
      text: (
        <p>
          Avaliação e tratamento da dor e das limitações de movimento, com foco
          em reabilitação e prevenção de lesões.
        </p>
      ),
    },
    {
      id: 2,
      image: terapias_fisio,
      title: "Fisioterapia Pélvica",
      text: (
        <p>
          Cuidado especializado para o assoalho pélvico, ajudando em
          incontinência, dor pélvica e saúde íntima.{" "}
          <strong>Atenção à grávida no pré e pós parto.</strong>
        </p>
      ),
    },
    {
      id: 3,
      image: terapias_fisio,
      title: "Fisioterapia/Terapia de Bowen",
      text: (
        <p>
          Técnica suave de terapia manual que trabalha músculos, tendões,
          ligamentos e fáscias para restaurar o equilíbrio do corpo, aliviar
          dores e tensões, e promover a recuperação natural do organismo.
        </p>
      ),
    },
    {
      id: 4,
      image: terapias_fisio,
      title: "Fisiatria",
      text: (
        <p>
          Consulta médica para diagnóstico e orientação de reabilitação, com
          plano de tratamento para dor e disfunções musculoesqueléticas.
        </p>
      ),
    },
    {
      id: 5,
      image: terapias_fisio,
      title: "Pilates Clínico",
      text: (
        <p>
          Exercícios terapêuticos programados individualmente, guiados para
          fortalecer, melhorar postura, dor, mobilidade e estabilidade com
          segurança.
        </p>
      ),
    },
    {
      id: 6,
      image: terapias_osteopatia,
      title: "Osteopatia",
      text: (
        <p>
          <b>Osteopatia</b> é uma terapia que utiliza a manipulação do corpo
          (esqueleto, músculos, ligamento e tecidos) para reduzir o desconforto,
          melhorar o movimento articular e restaurar o bem-estar.
        </p>
      ),
    },
    {
      id: 7,
      image: terapias_nutricao,
      title: "Nutrição Funcional",
      text: (
        <p>
          A <b>Nutrição Funcional</b> parte do princípio que cada um de nós tem
          necessidades diferentes com expressão genética, reações alimentares e
          ritmos biológicos únicos.
        </p>
      ),
    },
    {
      id: 8,
      image: terapias_massagem,
      title: "Massagem de Recuperação",
      text: (
        <p>
          A <b>Massagem de Recuperação</b> implica a utilização de um conjunto
          de técnicas específicas orientadas para aumentar a flexibilidade
          muscular e tonificar os tecidos, dando especial atenção a determinadas
          partes de corpo.
        </p>
      ),
    },
    {
      id: 9,
      image: terapias_estetica,
      title: "Estética Facial",
      text: (
        <p>
          Com o foco em melhorar a saúde da pele, textura, firmeza e vitalidade.
          Tratamentos que atenuam os sinais do envelhecimento e previnem o
          envelhecimento precoce da pele. Planos de tratamento para acne,
          manchas, flacidez, rejuvenescimento.
        </p>
      ),
    },
    {
      id: 10,
      image: terapias_estetica,
      title: "Estética Corporal",
      text: (
        <p>
          Protocolos corporais para tratar estrias, melhorar contorno, reduzir
          retenção de líquidos e celulite e aumentar a firmeza da pele.
        </p>
      ),
    },
    {
      id: 11,
      image: terapias_presso,
      title: "Pressoterapia",
      text: (
        <p>
          Simula a drenagem linfática manual. Reduz a retenção de líquidos,
          alivia a sensação de peso nas pernas, o inchaço e melhora a
          circulação. É auxiliar nos tratamentos para celulite.
        </p>
      ),
    },
    {
      id: 12,
      image: terapias_drenagem,
      title: "Drenagem Linfática Manual",
      text: (
        <p>
          A <b>Drenagem Linfática Manual</b> é uma técnica de massagem cujos
          movimentos aplicados são constantes, ritmados e precisos, de leve
          pressão, capazes de estimular o sistema linfático, acelerando o
          processo de transporte da linfa para os gânglios linfáticos.
        </p>
      ),
    },
    {
      id: 13,
      image: terapias_relax,
      title: "Massagem de Relaxamento",
      text: (
        <p>
          A <b>Massagem de Relaxamento</b> proporciona o alívio das tensões
          musculares e do stress.
        </p>
      ),
    },
  ];

  const [openIds, setOpenIds] = useState([]);

  const handleDivClick = (id) => {
    if (openIds.includes(id)) {
      setOpenIds(openIds.filter((openId) => openId !== id));
    } else {
      setOpenIds([...openIds, id]);
    }
  };

  return (
    <div className="container" style={{ textAlign: "-webkit-center" }}>
      <div className="row">
        {terapiasData.map((terapia) => (
          <div
            className="col-xl-4 col-lg-6 col-xs-12 mb-5 pb-4"
            key={terapia.id}
          >
            <div className="terapia-item">
              <div className="terapias-container">
                <img
                  style={{ width: "360px" }}
                  src={terapia.image}
                  alt={terapia.title}
                ></img>
                <div className="terapias-overlay">
                  <h2 className="text-uppercase">{terapia.title}</h2>
                </div>
              </div>
              <div
                className="terapias-clicable p-3 pb-3 text-justify"
                style={{ backgroundColor: "rgb(237 213 169 / 75%)" }}
                onClick={() => handleDivClick(terapia.id)}
              >
                {terapia.text}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TerapiasComponent;
